import { Box, BoxProps, styled, useTheme } from "@mui/material";
import Image from "next/image";
import { useMemo } from "react";

interface KeiFileViewerProps extends BoxProps {
  file?: File;
  placeholder: string;
  imageProps?: BoxProps<"img">;
}

export const KeiFileViewer = ({
  file,
  placeholder,
  imageProps,
  ...boxProps
}: KeiFileViewerProps) => {
  const theme = useTheme();
  const url = useMemo(() => {
    if (!file) return placeholder;
    return URL.createObjectURL(file);
  }, [file, placeholder]);

  const isEmbed = file && !file.type.startsWith("image");

  const { sx, ...props } = imageProps ?? {};

  return (
    <Box
      padding={1.5}
      bgcolor="background.default"
      borderRadius="0.5rem"
      sx={{
        border: `1px solid ${theme.palette.grey[300]}`,
      }}
      {...boxProps}
    >
      <Box bgcolor="grey.300">
        <Box
          bgcolor="grey.300"
          width="100%"
          height="15rem"
          component={isEmbed ? "embed" : "img"}
          src={`${url}#toolbar=0`}
          data={url}
          alt="file preview"
          sx={{
            objectFit: "contain",
            ...sx,
          }}
          {...props}
        />
      </Box>
    </Box>
  );
};
